import { Injectable, Inject } from '@angular/core';
import { MM_CONFIG, MMConfig } from './mm.config';
import {REPORTING_CONFIG, ReportingConfig} from '@docma-mm-core/config/reporting.config';

// @Injectable({
//   providedIn: 'root'
// })
@Injectable()
export class ConfigService {

  constructor(@Inject(MM_CONFIG) private mmConfig,
              @Inject(REPORTING_CONFIG) private reportingConfig) {

    console.log('ctor ConfigService');
  }

  getMmConfig(): MMConfig {
    return this.mmConfig;
  }

  getReportingConfig(): ReportingConfig {
    return this.reportingConfig;
  }
}
